import React, { Component } from "react";
import ReactDOM from "react-dom";
import LoadingOverlay from "react-loading-overlay";

LoadingOverlay.propTypes = undefined;

class SimpleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      container: null,
    };
  }

  componentDidMount() {
    const app = document.getElementsByClassName("app");
    if (app.length > 0) {
      this.setState({
        container: app[0],
      });
    }
  }

  render() {
    const { title, loading, visible, content, styles, onClickClose } =
      this.props;

    if (!visible || !this.state.container) {
      return null;
    }

    return ReactDOM.createPortal(
      <div
        className="app-popup app-popup-show"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="padding-top-20px" />
        <div
          className="popup-content background-white border-radius"
          style={{ width: "70%", ...styles }}
        >
          <LoadingOverlay active={loading} spinner>
            <div id="header" className="popup-panel grid grid-2x">
              <div className="col-1">
                <div className="popup-title">{title}</div>
              </div>
              <div className="col-2 content-right">
                <button
                  className="btn btn-circle btn-grey"
                  onClick={onClickClose}
                >
                  <i className="fa fa-lg fa-times" />
                </button>
              </div>
            </div>
            <div id="body">{content}</div>
          </LoadingOverlay>
        </div>
      </div>,
      this.state.container
    );
  }
}

SimpleModal.defaultProps = {
  loading: false,
};

export default SimpleModal;
